import HolidayManagementNursingCareForm from './HolidayManagementNursingCareForm';

export default HolidayManagementNursingCareForm;
